import React from 'react';
import { createRoot } from 'react-dom/client';
import { AlpineComponent } from 'alpinejs';
import { default as WatchListRoot } from './components/WatchList';

const WatchList = (): AlpineComponent<unknown> => ({
  init() {
    const config = JSON.parse(this.$root.dataset.jsConfig as string);

    const root = createRoot(this.$root);

    root.render(<WatchListRoot {...config} />);
  }
});

export default WatchList;
